import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { UserService } from 'services'

@Component({
    selector: 'app-onboarding',
    template: require('./onboarding.component.html'),
    styles: [require('./onboarding.component.scss')],
    host: { class: "" }
})

export class OnBoardingComponent implements OnInit {

    currentStep: number = 1;
    showOnBoarding: boolean = true;
    
    constructor(
        private router: Router,
        private userService: UserService
    ) { }

    ngOnInit() {
        const onBoarded = localStorage.getItem("sh:onboarded") === "true";
        const nonMember = this.userService.userHasClaim('NonMember');
        
        if (onBoarded || !nonMember) {
            this.showOnBoarding = false;
        }
    }

    prevStep() {
        this.currentStep--;
    }

    nextStep(form: NgForm) {
        if (form && form.valid) {
            this.currentStep++;
        } else if (!form) {
            this.currentStep++;
        }
    }

    joinSuperhog() {
        this.showOnBoarding = false;
        this.router.navigate(['/guest/dashboard/', { outlets: { section: ['guest-onboarding'] } }]);
    }

    skipToDashboard() {
        this.showOnBoarding = false;
        localStorage.setItem("sh:onboarded", "true");
        this.router.navigate(['/guest/dashboard/']);
    }
}
